


















import Vue from 'vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XCopyButton from '@/components/atoms/Button/XCopyButton.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import gql from 'graphql-tag'

type Data = {
  url: string
}

type Props = {
  partnerId: string
}

export default Vue.extend<Data, {}, {}, Props>({
  name: 'RegisterUrl',
  components: { XCard, XCopyButton, XInput },
  data: function () {
    return {
      url: '',
    }
  },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
  },
  apollo: {
    fetch: {
      query: gql`
        query partner($partnerId: ID!) {
          partner(partnerId: $partnerId) {
            partnerId
            storeOwnerRegistrationUrl
          }
        }
      `,
      variables() {
        return { partnerId: this.partnerId }
      },
      update({ partner }) {
        this.url = partner.storeOwnerRegistrationUrl
      },
    },
  },
})
